<template>
  <div class="dropdown dropdown-hover">
    <router-link :to="{name: 'ShoppingCart'}">
      <span><i class="icon nav-cart" /></span>
      <span id="shoppingCartCount" class="label label-success label-count">{{ cartSummary.ItemCount }}</span>
    </router-link>
  </div>
</template>

<script>
  import { mapGetters } from "vuex"
  import { ShoppingCartService } from "@/services/ShoppingCartService"
  import { ErrorLogService } from "@/services/ErrorLogService"

  export default { 
    computed: {
      ...mapGetters([
        "user",
        "activeAccountId",
        "cartSummary",
      ])
    },
    mounted: function () {
      this.$store.dispatch("LOAD_CART_SUMMARY", {accountId: this.activeAccountId, userId: this.user.UserId})
    },
  }
</script>
